<template>
  <div v-if="productType==='plot'" class="container">
    <unit-title title="权威检测" />
    <div class="test-report-list">
      <div v-for="(item,key) in testReportList" :key="key" class="report-list-item">
        <test-report-list-item :item="item" />
      </div>
    </div>
  </div>
  <div v-else class="container">
    <unit-title title="权威检测" />
    <div class="test-report-list">
      <div v-for="(item,key) in testReportList" :key="key" class="report-item">
        <!-- 包装溯源为 photo 种植溯源为 pic-->
        <van-image v-for="(i,index) in item.photo" :key="i.url" class="image" fit="cover" :src="i.url" @click="showImage(item.photo, index)" />
        <div class="text-info">
          <div class="text-info-item">
            <span class="label">颁证名称:</span> <span class="content">{{ item.testProject }}</span>
          </div>
          <div class="text-info-item">
            <span class="label">颁证机构:</span> <span class="content">{{ item.testFacility }}</span>
          </div>
          <div class="text-info-item">
            <span class="label">颁证编号:</span> <span class="content">{{ item.reportNo }}</span>
          </div>
          <div class="text-info-item">
            <span class="label">颁证日期:</span> <span class="content">{{ formatTime(item.issueDate, 'YYYY-MM-DD') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/convert/convertTime'
import { firstImgThumb } from '@/filter'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import TestReportListItem from '@/views/productManage/TraceSource/components/TestReportListItem'
import { ImagePreview } from 'vant'

export default {
  name: 'TestReportList',
  filters: { firstImgThumb },
  components: { TestReportListItem, UnitTitle },
  props: {
    testReportList: {
      type: Array,
      default() {
        return []
      }
    },
    productType: {
      type: String,
      default: 'plot'
    }
  },
  methods: {
    formatTime,
    showImage(imgArr, index) {
      let picUrlArr = []
      if (imgArr && imgArr.length) {
        picUrlArr = imgArr.map(item => item.url)
      }
      if (picUrlArr.length) {
        ImagePreview({
          images: picUrlArr,
          startPosition: index,
          closeable: true
        })
      } else {
        this.$toast('暂无图片')
      }
    }
  }
}
</script>

<style lang='less' scoped>
.report-list-item + .report-list-item {
  margin-top: 10px;
}
.image{
  margin-right: 10px;
}
.report-item {
  display: flex;
  .image {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }
}
.text-info-item {
  .label {
    word-break: keep-all;
    white-space: nowrap;
  }
  .content {
    word-break: break-all;
  }
}
</style>
